// Shared visual style presets for the property site (PropertyLanding) and the
// Welcome Book (GuestbookApp). Background stays white in every preset; presets
// drive the FONT and the BUTTON/ACCENT colours. Text colour is always chosen for
// contrast so labels stay readable on any palette.

const _shift = (hex, amt) => {
  const h = (hex || "#000000").replace("#", "");
  const c = [0, 2, 4].map((i) => {
    const v = parseInt(h.slice(i, i + 2), 16) + amt;
    return Math.max(0, Math.min(255, v));
  });
  return "#" + c.map((v) => v.toString(16).padStart(2, "0")).join("");
};

// Readable text colour (dark on light backgrounds, white on dark ones).
export const readableText = (hex) => {
  const h = (hex || "#000000").replace("#", "");
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const L = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return L > 0.62 ? "#1a1a1a" : "#ffffff";
};

// Gradient for landing buttons (keeps the hue vivid).
export const gradientFromHex = (hex) => `linear-gradient(135deg, ${_shift(hex, 28)} 0%, ${hex} 55%, ${_shift(hex, -34)} 100%)`;

// Darker gradient for Welcome Book tiles so white tile text always reads well.
export const tileGradient = (hex) => `linear-gradient(135deg, ${_shift(hex, -8)} 0%, ${_shift(hex, -42)} 55%, ${_shift(hex, -80)} 100%)`;

// rgba helper from a hex colour.
const _rgba = (hex, a) => {
  const h = (hex || "#000000").replace("#", "");
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

// Soft, "estivo" tint for the big landing canvas boxes (info casa, video, la casa).
// Very light gradient derived from the preset accent so all sections feel uniform.
export const boxTint = (hex) => ({
  bg: `linear-gradient(180deg, ${_rgba(hex, 0.05)} 0%, ${_rgba(hex, 0.12)} 100%)`,
  border: _rgba(hex, 0.22),
  orb1: `radial-gradient(circle, ${_rgba(hex, 0.14)}, transparent 70%)`,
  orb2: `radial-gradient(circle, ${_rgba(hex, 0.09)}, transparent 70%)`,
});

export const THEME_PRESETS = {
  hostland: {
    id: "hostland",
    name: "Hostland Style",
    desc: "Colori pop, moderno",
    font: "Space Grotesk",
    accent: "#d04260",
    buttons: ["#6366F1", "#F43F5E", "#8B5CF6", "#10B981", "#FF3B30", "#0EA5E9", "#C026D3", "#F59E0B"],
  },
  minimal: {
    id: "minimal",
    name: "Minimal Style",
    desc: "Terroso, essenziale",
    font: "Space Grotesk",
    accent: "#6F4E37",
    buttons: ["#6F4E37", "#C08A2D", "#B8860B", "#3E8E7E", "#8A7A5C", "#A9744F", "#4F6F52", "#9C6B3F"],
  },
  fluo: {
    id: "fluo",
    name: "Hostland Fluo",
    desc: "Bold, colori fluo",
    font: "Space Grotesk",
    accent: "#FF1FA6",
    buttons: ["#FFD400", "#FF2D2D", "#FF1FA6", "#00E08A", "#7C3AED", "#00D4FF", "#FF7A00", "#B6FF00"],
  },
  business: {
    id: "business",
    name: "Hostland Business",
    desc: "Elegante, sobrio",
    font: "Playfair Display",
    accent: "#111827",
    buttons: ["#111827", "#374151", "#B91C1C", "#065F46", "#6B7280", "#1F2937", "#7F1D1D", "#0F3D2E"],
  },
};

export const PRESET_LIST = [THEME_PRESETS.hostland, THEME_PRESETS.minimal, THEME_PRESETS.fluo, THEME_PRESETS.business];
export const getPreset = (id) => THEME_PRESETS[id] || THEME_PRESETS.hostland;
